import { ymd } from "./util";

const iso = (s) => (s ? String(s).slice(0, 10) : "");
export const noteDate = (n) => iso(n.scheduledFor) || iso(n.apptAt) || ymd(new Date(n.createdAt));

const fields = (n) => [
  ["Title", n.title], ["Ref #", n.ref], ["Tracking #", n.receipt?.tracking], ["Status", n.receipt?.status],
  ["Vendor", n.receipt?.vendor], ["Invoice #", n.receipt?.invoice], ["Carrier", n.receipt?.carrier],
  ["Location", n.location], ["Context", n.context], ["Tags", Array.isArray(n.tags) ? n.tags.join(" ") : n.tags],
  ["Date", [...new Set([ymd(new Date(n.createdAt)), n.scheduledFor, n.apptAt && n.apptAt.replace("T", " "), n.receipt?.date, n.deadline, n.healthDate].filter(Boolean))].join("  ")],
  ["Note", n.body],
].filter(([, v]) => v);

const RANGES = { "7d": 7, "30d": 30, "12m": 365 };
export function inRange(n, { range, from, to }) {
  const d = noteDate(n);
  if (RANGES[range]) return d >= ymd(new Date(Date.now() - RANGES[range] * 86400000));
  return (!from || d >= from) && (!to || d <= to);
}

function snippet(label, text, phrase, first) {
  const term = text.toLowerCase().includes(phrase) ? phrase : first;
  if (label === "Date") text = text.split("  ").find((d) => d.toLowerCase().includes(term)) || text;
  const i = text.toLowerCase().indexOf(term);
  if (label !== "Note") return { label, text, i, len: term.length };
  const start = Math.max(0, i - 40);
  const s = text.slice(start, start + 140).replace(/\s+/g, " ");
  return { label, text: (start ? "…" : "") + s, i: s.toLowerCase().indexOf(term) + (start ? 1 : 0), len: term.length };
}

export function searchNotes(notes, q, f) {
  const terms = q.toLowerCase().split(/\s+/).filter(Boolean);
  const out = [];
  for (const n of notes) {
    if (f.folderId && n.folderId !== f.folderId) continue;
    if (f.status && n.receipt?.status !== f.status) continue;
    if (!inRange(n, f)) continue;
    const fs = fields(n);
    const hay = fs.map(([, v]) => String(v).toLowerCase()).join("\n");
    if (!terms.every((t) => hay.includes(t))) continue;
    const hit = terms.length ? fs.find(([, v]) => String(v).toLowerCase().includes(terms[0])) : null;
    const score = terms.length ? (String(n.title).toLowerCase().includes(terms[0]) ? 2 : hit[0] === "Note" ? 0 : 1) : 0;
    out.push({ note: n, date: noteDate(n), score, hit: hit && hit[0] !== "Title" ? snippet(hit[0], String(hit[1]), terms.join(" "), terms[0]) : null });
  }
  return out.sort((a, b) => b.score - a.score || b.date.localeCompare(a.date)).slice(0, 50);
}
